
<script>
import TextInput from "@/components/TextInput";
import ErrorMessage from "@/components/ErrorMessage";
import Button from "@/components/Button";
import Captcha from "@/components/Captcha";
import bus from "@/bus";
import { useUserStore } from "../../stores/user";

// 401 is a bad credentials by default
// 403 the user credential are valid, but it is not able to connect, the account is not validated yet.
// 5xx is an internal server error/ or unrecoverable error
const statusCodes = {
  401: "views.modals.login.401",
  403: "views.modals.login.403",
  500: "views.modals.login.500",
};

export default {
  setup() {
    const userStore = useUserStore();
    return { userStore };
  },
  components: {
    Button,
    TextInput,
    ErrorMessage,
    Captcha,
  },
  data() {
    return {
      email: "",
      password: "",
      errors: [],
      loginState: 0,
      valid: true,
    };
  },
  computed: {
    loginButton() {
      // loginState values:
      // 0: Not logged in yet
      // 1: Logging in
      if (this.loginState === 1) {
        return {
          icon: "spinner",
          text: "views.modals.login.state.1",
          color: "gray-700",
        };
      }
      return {
        icon: "sign-in-alt",
        text: "views.modals.login.state.2",
        color: "airbnbRed",
      };
    },
  },
  methods: {
    openModal(modal) {
      bus.emit("openModal", {
        modal,
      });
    },
    async login() {
      try {
        this.loginState = 1;
        const { email, password, valid } = this;
        const error = await this.userStore.login({
          email,
          password,
          valid,
        });
        if (error) {
          const message = error.data;
          this.loginState = 0;
          this.errors.push({
            id: this.errors.length,
            message: statusCodes[error.status] || message,
          });
        }
        this.loginState = 0;
      } catch (err) {
        console.error(err);
        this.errors.push({
          id: this.errors.length,
          message: statusCodes[500],
        });
        this.loginState = 0;
      }
    },
    closeMessage(id) {
      Object.keys(this.errors).forEach((key) => {
        if (id === this.errors[key].id) {
          this.errors.splice(key, 1);
        }
      });
    },
  },
};
</script>

<template>
  <div class="w-full p-5 lg:w-1/3 min-w-1/3">
    <h1 class="mb-6 text-3xl font-light text-gray-700">
      {{ $t("views.modals.login.sign") }}
    </h1>
    <br />
    <div v-for="msg in errors" :key="msg.id">
      <ErrorMessage :value="msg" @input="closeMessage" />
    </div>
    <form data-cy="loginForm" @submit.prevent="login">
      <TextInput id="loginMail" v-model="email" data-cy="loginMail" :label="$t('views.modals.login.email')" type="email"
        class="mb-4" />
      <TextInput id="loginPass" v-model="password" data-cy="loginPassword" :label="$t('views.modals.login.password')"
        type="password" class="mb-4" />
      <Captcha v-model="valid" />
      <div class="w-full flex flex-items-center justify-between">
        <div class="block">
          <a href="#" class="text-sm text-blue-700 hover:text-blue-800" @click="openModal('resetPassword')">{{
            $t("views.modals.login.reset_password") }}</a>
          <br />
        </div>
        <Button data-cy="loginButton" class="text-sm" :bg="loginButton.color" type="submit">
          <font-awesome-icon :icon="loginButton.icon" class="mr-1" :spin="loginState === 1" />
          <span>{{ $t(loginButton.text) }}</span>
        </Button>
      </div>
    </form>
  </div>
</template>
